import styled, { css } from 'styled-components'

import type { StyledGroupWrapperProps } from './types'

export const GroupWrapper = styled.div<StyledGroupWrapperProps>`
  column-gap: 10px;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: normal;
  line-height: 1.2;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.crystalBay};
  border-radius: 8px;
  padding: 14px;
  display: flex;

  width: 100%;
  transition:
    border-color,
    ease 350ms;

  ${({ $readOnly }) =>
    $readOnly &&
    css`
      background: ${({ theme }) => theme.colors.catskillWhite};
    `}

  ${({ $error }) =>
    $error &&
    css`
      border-color: ${({ theme }) => theme.colors.danger};
    `}
`
